import * as types from 'modules/checklists/actionTypes';
import type { SetIsNewAction } from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsNewChecklistTargetReducer = { dealerId: string | null; groupId: string | null };

const initialState: ChecklistUiDetailsNewChecklistTargetReducer = {
  dealerId: null,
  groupId: null,
};

const update = (
  _: ChecklistUiDetailsNewChecklistTargetReducer,
  { meta }: SetIsNewAction
): ChecklistUiDetailsNewChecklistTargetReducer => meta as ChecklistUiDetailsNewChecklistTargetReducer;

export default createReducer(initialState, {
  [types.SET_IS_NEW]: update,
});
